export default __webpack_public_path__ + "static/media/wac.9d7ba9d1.jpeg";